"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertCubicMetersToPalletCount = void 0;
const PALLETS_PER_CUBIC_METER = 1.5;
const convertCubicMetersToPalletCount = (cubicMeters) => {
    return Math.ceil(cubicMeters / PALLETS_PER_CUBIC_METER);
};
exports.convertCubicMetersToPalletCount = convertCubicMetersToPalletCount;
//# sourceMappingURL=ContainerUtils.js.map